export function initString(value) {
  let truthyValue = value ?? "";
  const stringValue =
    typeof truthyValue !== "string" ? String(truthyValue) : truthyValue;
  return stringValue;
}
